import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-14 text-center md:px-10 md:py-16">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-background-50/10" />
          <div className="absolute -bottom-20 -left-16 h-64 w-64 rounded-full bg-background-50/10" />

          <div className="relative z-10 mx-auto max-w-2xl">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-4xl">
              {t("cta.title")}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-100 md:text-base">
              {t("cta.subtitle")}
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 sm:w-auto"
              >
                {t("cta.primary")}
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
              >
                {t("cta.secondary")}
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}